<template src="./index.html"></template>
<style src="./style.scss" lang="scss" scoped></style>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Navbar from '@/components/Navbar';
import ProgressBar from '@/components/ProgressBar';
import BackButton from '@/components/BackButton';
import CustomButton from '@/components/CustomButton';
import Background from '@/components/Background';
import CallFlowNumber from '@/components/CallFlowNumber';
import TextFlowModal from '@/components/TextFlowModal';
import ScheduleModal from './components/ScheduleModal';
import CallFlowCard from './components/CallFlowCard';
import CallFlowButton from './components/CallFlowButton';
import CallFlowVoicemailCard from './components/CallFlowVoicemailCard';
import CallMenuModal from './components/CallMenuModal';
import CallMenuItem from './components/CallMenuItem';
import DeleteCallMenu from './components/DeleteCallMenu';
import PlayRecordingModal from './components/PlayRecordingModal';
import { ROUTE_TYPES, ACTION_TYPES } from '@/constants';
import { M_SET_CALL_FLOW_TO_MENU, M_ONBOARDING_STEP, M_S3_GREETING_UPLOAD } from '@/graphql';
import { removeSpaceFromString } from '@/utils';

const dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const hoursType = {
  working: 'working',
  nonworking: 'nonworking',
  all: 'all'
};
const scheduleOptions = {
  all: {
    key: 'all',
    hoursTypes: [hoursType.all],
    hoursTypesTitle: ['Schedule'],
    text: '24/7'
  },
  hours: {
    title: 'hours',
    key: 'hours',
    hoursTypes: [hoursType.working, hoursType.nonworking],
    hoursTypesTitle: ['Working hours', 'Non working hours'],
    text: ''
  }
};

export default {
  name: 'CallMenu',
  components: {
    Navbar,
    ProgressBar,
    BackButton,
    CustomButton,
    Background,
    CallFlowNumber,
    CallFlowCard,
    CallFlowVoicemailCard,
    ScheduleModal,
    CallFlowButton,
    DeleteCallMenu,
    PlayRecordingModal,
    CallMenuModal,
    CallMenuItem,
    TextFlowModal
  },
  data() {
    return {
      ACTION_TYPES,
      isLoading: false,
      scheduleModalVisible: false,
      playRecordingModalVisible: false,
      deleteCallMenuVisible: false,
      callMenuModalVisible: false,
      textFlowModalVisible: false,

      scheduleType: 'all',
      scheduleTimezone: '',
      scheduleDays: null,

      playRecordingAction: '',
      currentKey: null,
      dataType: null,

      storingAudio: false,

      scheduleOptions,
      callMenu: {
        all: {
          action: null,
          target: null,
          numbers: []
        },
        working: {
          action: null,
          target: null,
          numbers: []
        },
        nonworking: {
          action: null,
          target: null,
          numbers: []
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      groups: 'auth/getUserGroups',
      team: 'auth/getUserFullTeam',
      phoneName: 'onboarding/getSelectedName',
      phoneNumber: 'onboarding/getSelectedNumberFormatted',
      phoneId: 'onboarding/getSelectedId',
      callFlow: 'onboarding/getSelectedCallFlow'
    }),

    editing() {
      return {
        type: this.scheduleType,
        timezone: this.scheduleTimezone,
        days: this.scheduleDays
      };
    },

    btnDisabled() {
      if (this.scheduleType === this.scheduleOptions.all.key) {
        const blocked = this.checkCallMenuFilled(this.callMenu.all);
        return blocked;
      } else {
        const blockedWorking = this.checkCallMenuFilled(this.callMenu.working);
        const blockedNonWorking = this.checkCallMenuFilled(this.callMenu.nonworking);
        return blockedWorking || blockedNonWorking;
      }
    },

    scheduleTypeSelected() {
      const hoursUsed = Object.keys(hoursType).filter((key) => {
        return this.callFlow.callMenu.some((callMenu) => callMenu.hoursType === key);
      });
      if (hoursUsed.length === 0) {
        return scheduleOptions.all;
      } else if (hoursUsed.length === 1 && hoursUsed[0] === hoursType.all) {
        return scheduleOptions.all;
      } else {
        return scheduleOptions.hours;
      }
    },

    hasGroup() {
      return this.groups.filter((group) => group.isCreated === true).length > 0;
    }
  },
  mounted() {
    if (this.callFlow && this.callFlow.type === ROUTE_TYPES.ROUTE_MENU) {
      const allHours = this.callFlow.callMenu.some((menu) => menu.hoursType === hoursType.all);
      this.scheduleType = allHours ? scheduleOptions.all.key : scheduleOptions.hours.key;
      const types = scheduleOptions[this.scheduleType].hoursTypes;
      types.forEach((type) => {
        const existingCallMenu = this.callFlow.callMenu.find((menu) => menu.hoursType === type);
        this.callMenu[type] = {
          ...this.callMenu[type],
          ...existingCallMenu
        };
      });

      if (!allHours) {
        const { lineSchedule: ls } = this.callFlow;
        this.scheduleTimezone = ls.timezone;
        this.scheduleDays = dayList.reduce((days, key) => {
          if (ls.lineOpen[key]) {
            return {
              ...days,
              [key]: {
                from: `${parseInt(ls.lineOpen[key][0], 10)} ${ls.lineOpen[key][0].slice(-2).toUpperCase()}`,
                selected: true,
                to: `${parseInt(ls.lineOpen[key][1], 10)} ${ls.lineOpen[key][1].slice(-2).toUpperCase()}`
              }
            };
          }
          return {
            ...days,
            [key]: {
              from: '9 AM',
              selected: false,
              to: '6 PM'
            }
          };
        }, {});
      }
    }
  },
  methods: {
    onEditCallMenuRecording(type) {
      this.dataType = type;
      this.playRecordingAction = 'callmenu';
      this.playRecordingModalVisible = true;
    },

    onEditCallMenuNumbers(type) {
      this.dataType = type;
      this.callMenuModalVisible = true;
    },

    onDeleteCallMenu(type) {
      this.dataType = type;
      this.deleteCallMenuVisible = true;
    },

    deleteCallMenu() {
      this.callMenu[this.dataType] = {
        action: null,
        target: null,
        numbers: []
      };
      this.deleteCallMenuVisible = false;
    },

    cancelDeleteCallMenu() {
      this.deleteCallMenuVisible = false;
    },

    /**
     * Handle "Play Recording" modal visibility
     * @param isVisible {boolean} - modal visibility
     * @returns {boolean}
     */
    editVoicemail(menuType) {
      this.dataType = menuType;
      this.playRecordingAction = 'voicemail';
      this.playRecordingModalVisible = true;
    },

    /**
     * Delete "Voicemail Card"
     * @param cardOptions menuType - Audio Card options
     * @returns {*}
     */
    deleteVoicemail(menuType) {
      if (this.callMenu[menuType].action === ACTION_TYPES.ACTION_VOICEMAIL) {
        this.callMenu[menuType].action = null;
        this.callMenu[menuType].target = null;
      }
    },

    onEditScheduleModule() {
      this.scheduleModalVisible = true;
    },

    onSaveSchedule(type, timezone, days) {
      this.scheduleModalVisible = false;
      this.scheduleType = type;
      this.scheduleTimezone = timezone;
      this.scheduleDays = days;
    },

    onCancelSchedule() {
      this.scheduleModalVisible = false;
    },

    /**
     * Select Call Menu action
     * @param action {string} - selected action
     * @param data {*} - corresponding data
     * @param type {string} - schedule type
     * @returns {void}
     */
   deleteTarget(action, data, type) {
      this.callMenu[type].target = 0;
    },
     selectFlowAction(action, data, type, callMenuNumber, existing) {
     
      
      this.dataType = type;
      this.callMenu[type].action = action;
      this.callMenu[type].numbers = [];
      if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP || this.playRecordingAction === 'number_routing' || this.playRecordingAction === 'number_voicemail') {
                

        this.playRecordingAction = 'direct_routing';
        this.playRecordingModalVisible = true;
        if (!existing) {
          this.callMenu[type].target = { id: data };
        }
      } else {
        
        this.callMenu[type].target = data;     
      }
    },

    /**
     * Select action for ALL type
     * @param action {string} - action that was selected
     * @param data {*} - action-related data
     * @param type {string} - type of the Call Menu (all, hours)
     * @param callMenuNumber { number }
     * @returns {*}
     */
    selectMenuAction(action, data, type, callMenuNumber, isTarget = false, isMenu = false) {
  
                       

      if (!(this.callMenu[type].numbers && this.callMenu[type].numbers.length > 0) || isMenu) {
        
        if(isTarget)
       
        {
            this.dataType = type;
        this.callMenu[type].action = action;
        if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP) {
          this.playRecordingAction = 'direct_routing';
          this.playRecordingModalVisible = true;
          this.callMenu[type].target = { id: data };
        } else {
          this.callMenu[type].target = data;
        }
  
          
          
                            this.playRecordingAction = 'direct_routing';
          this.playRecordingModalVisible = true;          
        }
  else
  {

       this.dataType = type;
        this.callMenu[type].action = action;
        this.callMenu[type].numbers = [];
        if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP) {
          this.playRecordingAction = 'direct_routing';
          this.playRecordingModalVisible = true;
          this.callMenu[type].target = { id: data };
        } else {
          this.callMenu[type].target = data;
        }
  

  }
     
     
      }           else {


       
       
                     
        this.dataType = type;
        this.callMenu[type].numbers.forEach((num) => {
          if (num.key === callMenuNumber) {
            
                if(isTarget)
       
        {
                                  

        num.action = action;

          

            if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP) {
              this.currentKey = num.key;
              this.playRecordingAction = 'number_routing';
              this.playRecordingModalVisible = true;
         
            } else if (action === ACTION_TYPES.ACTION_VOICEMAIL) {
              this.currentKey = num.key;
              this.playRecordingAction = 'number_voicemail';
              this.playRecordingModalVisible = true;

           
          
            }     
               

        }
    else
    {
         num.action = action;

            num.target = data;

            if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP) {
              this.currentKey = num.key;
              this.playRecordingAction = 'number_routing';
              this.playRecordingModalVisible = true;
              num.target = { id: data };
            } else if (action === ACTION_TYPES.ACTION_VOICEMAIL) {
              this.currentKey = num.key;
              this.playRecordingAction = 'number_voicemail';
              this.playRecordingModalVisible = true;

              num.target = data;
              if (!num.target) {
                num.target = { id: '' };
              }
            } else {
              num.target = data;
            }
          }
      

    }

         


        });
      }
    },

    /**
     * Save "Play recording" data: upload the file
     * @returns {boolean}
     */
    async savePlayRecordingData(currentKey, record) {

      this.storingAudio = true;

      try {
       let url = null;     let custom = ""
        custom = record.custom ? record.custom : ""
        let csText = ""
           let setsCustom = false;
        setsCustom = record.setsCustom;
        
        csText = record.csText ? record.csText : ""; 
        
        if (record.isEnabled && !record.isDefault && record.tab !== 'Text to audio') {
          const {
            data: { s3_greeting_upload }
          } = await this.$apollo.mutate({
            mutation: M_S3_GREETING_UPLOAD
          });
        
        
            if (this.playRecordingAction === 'callmenu' || this.playRecordingAction === 'voicemail'   || this.playRecordingAction === 'number_voicemail'  ) 
          {

            
        
          await axios.put(s3_greeting_upload.url, record.file, {
            headers: {
              'Content-Type':  record.file.type
            }
          });
          }
          else
          {
              await axios.put(s3_greeting_upload.url, record.customTarget, {
            headers: {
              'Content-Type': record.customTarget.type
            }
          });
     
          }
     
     
        
          url = 'https://voyyp-greetings.s3-accelerate.amazonaws.com/' + s3_greeting_upload.key;
          




          custom = url;
        }
        if(!record.isEnabled)
        {
        url =       record.target
        
        }
       
        if (this.playRecordingAction === 'callmenu' || this.playRecordingAction === 'voicemail') {
          this.callMenu[this.dataType].target = {
            url,
            text: record.text,
            tab: record.tab,
              setsCustom,
            isVoice: true,
               csText,
            custom, 
            duration: record.duration
          };
        } else if (this.playRecordingAction === 'direct_routing') {
          const prev = this.callMenu[this.dataType].target;
          this.callMenu[this.dataType].target = {
            id: typeof prev === 'number' ? prev : prev.id,
            url,
            text: record.text,
                isVoice: false,
            setsCustom,
               csText,
            custom, 
            tab: record.tab,
            duration: record.duration,
            isDefault: record.isDefault,
            isEnabled: record.isEnabled
          };
        } else if (this.playRecordingAction === 'number_routing' || this.playRecordingAction === 'number_voicemail') {
          const nums = this.callMenu[this.dataType].numbers.map((el) => {
            if (el.key === this.currentKey) {
              return {
                ...el,
                target: {
                  id: typeof el.target === 'number' ? el.target : el.target.id,
                  url,
                  text: record.text,
                      isVoice: this.playRecordingAction === 'number_voicemail' ? true : false,
                  setsCustom,
                
                     csText,
            custom, 
                  tab: record.tab,
                  duration: record.duration,
                  isDefault: record.isDefault,
                  isEnabled: record.isEnabled
                }
              };
            }
            return el;
          });
          this.callMenu[this.dataType].numbers = nums;
        }

        this.playRecordingModalVisible = false;
        this.storingAudio = false;
    
      } catch (error) {
        // Upload Failed
        console.log(error);
        this.storingAudio = false;
      }
    },

    closePlayRecordingModal() {
      if (this.playRecordingAction === 'number') {
        const nums = this.callMenu[this.dataType].numbers.map((el) => {
          if (el.key === this.currentKey) {
            return { ...el, action: null, target: null };
          }
          return el;
        });
        this.callMenu[this.dataType].numbers = nums;
      }
      this.playRecordingModalVisible = false;
    },
    selectFlowActionDatas(action, data, type, callMenuNumber, existing) {
      this.dataType = type;
      this.callMenu[type].action = action;
      this.callMenu[type].numbers = [];
      if (action === ACTION_TYPES.ACTION_PERSON || action === ACTION_TYPES.ACTION_GROUP) {
        this.playRecordingAction = 'direct_routing';
        this.playRecordingModalVisible = true;
        if (!existing) {
          this.callMenu[type].target = { id: data };
        }
      } else {
        this.callMenu[type].target = data;
      }
    },
    onSaveCallMenu(numbers) {
      this.callMenuModalVisible = false;
      // process & store selected numbers array
      const numbersArray = numbers
        .sort((a, b) => a - b)
        .map((num) => {
          const existedNum = this.callMenu[this.dataType].numbers.find((el) => el.key === num);
          return {
            action: '',
            key: num,
            ...existedNum
          };
        });
      this.callMenu[this.dataType].numbers = [...numbersArray];
    },

    onCancelCallMenu() {
      this.callMenuModalVisible = false;
    },

    /**
     * Get numbers from callMenuNumbers*
     * @param selectedNumbers {object[]} - array of the selected number objects
     * @returns {number[]}
     */
    getNumbers(selectedNumbers = []) {
      return Array.isArray(selectedNumbers) && selectedNumbers.length > 0
        ? selectedNumbers.map((item) => item.key)
        : [];
    },

    /**
     * Check Call Menu has all values required
     */
    checkCallMenuFilled(callMenu) {
      if (!callMenu.action || !callMenu.target) {
        return true;
      }
      if (callMenu.action === ACTION_TYPES.ACTION_MENU) {
        if (!callMenu.numbers.length) {
          return true;
        }
        return callMenu.numbers.some((menuItem) => !menuItem.action || !menuItem.target);
      }
      return false;
    },
    /**
     * Handle the route selection for the Text Flow modal
     */
    onRouteSelect(routeType = '') {
      this.textFlowModalVisible = false;
      this.$router.push(`/text-flow/${routeType}`);
    },

    createMenu(flow, type) {
      return {
        action: flow.action,
        target: flow.target,
        numbers: flow.numbers,
        hoursType: type
      };
    },

    /**
     * On "Next" button click
     * @returns {Promise<boolean>}
     */
    async saveFlow() {
      try {
        // enable the invitation button
        this.isLoading = true;
        const { scheduleType = 'all' } = this;
        const lineSchedule = {};
        if (scheduleType === 'hours') {
          lineSchedule.lineOpen = Object.keys(this.scheduleDays).reduce((days, key) => {
            if (this.scheduleDays[key].selected) {
              return {
                ...days,
                [key]: [
                  removeSpaceFromString(this.scheduleDays[key].from).toLowerCase(),
                  removeSpaceFromString(this.scheduleDays[key].to).toLowerCase()
                ]
              };
            }
            return days;
          }, {});
          lineSchedule.timezone = this.scheduleTimezone;
        }

        const callFlow = {
          type: ROUTE_TYPES.ROUTE_MENU,
          callMenu: []
        };
        if (this.scheduleType === scheduleOptions.all.key) {
          const menuOpen = this.createMenu(this.callMenu.all, scheduleOptions.all.key);
          callFlow.callMenu = [menuOpen, null];
        } else {
          const menuOpen = this.createMenu(this.callMenu.working, hoursType.working);
          const menuClosed = this.createMenu(this.callMenu.nonworking, hoursType.nonworking);
          callFlow.callMenu = [menuOpen, menuClosed];
        }

        // mutate store
        await this.$store.dispatch('onboarding/setCallFlow', {
          ...callFlow,
          lineSchedule
        });

        // send mutation request
        const result = await this.$apollo.mutate({
          mutation: M_SET_CALL_FLOW_TO_MENU,
          variables: {
            phoneNumberId: this.phoneId,
            openFlow: JSON.stringify(callFlow.callMenu[0]),
            closedFlow: JSON.stringify(callFlow.callMenu[1]),
            workingHours: scheduleType === 'hours' ? JSON.stringify(lineSchedule) : null
          }
        });

        await this.$apollo.mutate({
          mutation: M_ONBOARDING_STEP,
          variables: {
            user_id: this.user.id,
            onboarding_step: 4
          }
        });
        await this.$store.dispatch('onboarding/setOnboardingStep', 4);

        // enable the Next button
        this.isLoading = false;

        // show the SMS Routing modal
        return (this.textFlowModalVisible = true);
      } catch (error) {
        // enable the Next button
        this.isLoading = false;
        // TODO: handle errors
        console.log('ERROR', error);
      }
    }
  }
};
</script>
